import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Link } from '../Link';
import { LinkVariant } from '../../enums';
const BreadcrumbsItem = ({ children, href, rel, className, isLastItem = false, separator = '/', onClick, }) => {
    return (_jsx("li", { className: "d-flex mr-1x", children: isLastItem ? (_jsx("span", { children: children })) : (_jsxs(_Fragment, { children: [_jsx(Link, { rel: rel, href: href, variant: LinkVariant.Grey, className: className, onClick: (e) => onClick && onClick(e, href), children: children }), _jsx("span", { className: "ml-1x", children: separator })] })) }));
};
export { BreadcrumbsItem };
